<template>

        <v-card class="mx-auto coupondetail" max-width="400">
            <p v-if="push_date" class="detailhead">配信日時：{{push_date}}<br>対象店舗：{{item.shop_names}}</p>
            <p v-else class="detailhead">対象店舗：{{item.shop_names}}</p>
            <v-card class="mx-auto" max-width="400" outlined>
                <div class="topbar maincolor-bg"></div>

                <!-- 20201120 NEW_DEV-734 NO018 NO027 cyber 段 start -->
                <v-row justify="center" align="center" v-if="item.distribution_name && item.distribution_type == 2">
                    <div class="chips">
                        {{item.distribution_name}}
                    </div>
                </v-row>

                <v-row justify="center" align="center" v-if="item.distribution_name && item.distribution_type == 3">
                    <div class="chips birth">
                        {{item.distribution_name}}
                    </div>
                </v-row>
                <!-- 20201120 NEW_DEV-734 NO018 NO027 cyber 段 end -->

                <v-card-title class="coupontitle nl2br">{{item.title}}</v-card-title>

                <div class="titlebottombar maincolor-bg"></div>

                <v-card-title class="coupontitle nl2br">{{item.discount_text}}</v-card-title>

                <v-divider class="vdbar"></v-divider>

                <div class="coupon_contents" v-if="item.lottery_flg === 0 || item.scratch_flg == 1" v-html="item.comment"></div>
                <div class="coupon_contents" v-html="item.lottery_comment" v-else></div>

                <v-divider class="vdbar"></v-divider>

                <v-row class="list">
                    <v-col cols="3">
                        <h2>クーポン種別</h2>
                    </v-col>
                    <v-col cols="9">
                        <p>
                            {{item.distribution_name}}
                        </p>
                    </v-col>

                    <v-col cols="3">
                        <h2>有効期限</h2>
                    </v-col>
                    <v-col cols="9">
                        <p>
                            {{item.disp_date}}
                        </p>
                    </v-col>

                    <v-col cols="3">
                        <h2>注意事項</h2>
                    </v-col>
                    <v-col cols="9">
                        <p class="notes nl2br">{{item.attention}}</p>
                        <p v-if="item.text_type" v-html="item.text_type" class="notes"></p>
                    </v-col>
                </v-row>

                <v-divider class="vdbar2"></v-divider>

                <div v-if="item.publish_start_date_flg == 0"><!-- 1の場合は、事前クーポンの表示となるので、ボタン類は表示しない -->
                  <!-- NEW_DEV-2241 cyber start   -->
                  <v-content v-if="item.usage_count_limit > 0 && (item.lottery_flg === 0 || item.scratch_flg === 1)">
                    <div class="usage">残り <span class="maincolor big">{{item.usage_count_limit - item.usage_count}}</span><span class="maincolor bold">回／{{item.usage_count_limit}}回</span><br>使用できます</div>
                      <v-divider class="vdbar2"></v-divider>
                  </v-content>
                  <v-content v-else-if="item.usage_count_limit === 1 && (item.lottery_flg === 0 || item.scratch_flg === 1)">
                      <div class="usage">残り <span class="maincolor big">{{item.usage_count}}</span><span class="maincolor bold">回</span><br>使用できます</div>
                  </v-content>
                  <!-- NEW_DEV-2241 cyber end   -->
                  <div class="text-center pt-1 pb-6" v-if="item.usage_count_limit > 0">
                      <v-btn rounded class="maincolor-bg default_button" v-if="item.lottery_flg === 0 || item.scratch_flg === 1" @click.stop="openUseDialog(item)">クーポンを使用する</v-btn>
                      <app-dialogue ref="ticketDialogue"></app-dialogue>
                  </div>
                  <div class="text-center pt-1 pb-6" v-if="item.lottery_flg === 1 && (item.scratch_flg != 1 || item.scratch_flg == null)">
                      <v-btn rounded class="maincolor-bg default_button" @click.stop="lottery()">抽選をする</v-btn>
                  </div>

                  <scratchDialogue ref="scratchDialogue" :item="item" @getCoupon="closeWin"  @scratch="scratch"></scratchDialogue>
                </div>
                <div v-if="item.publish_start_date_flg == 1">
                  <p class="text-center caption" style="color:red;">有効期限前のクーポンのため、<br>クーポンは使用できません。</p>
                </div>

                <div class="text-center pb-3">
                  <!-- NEW_DEV-1422 cyber start -->
                  <v-btn rounded class="graybtn default_button" @click.stop="routerBack('coupon_list', false)">閉じる</v-btn>
                  <!-- NEW_DEV-1422 cyber end -->
                </div>
            </v-card>

            <v-overlay :value="used" absolute opacity="0.7" v-if="item.use_flg === 1">
                <div class="text-center">
                    <img class="img" src="@/assets/check.svg" width="30">
                    <p class="flgtext">チケット使用済み</p>
                </div>
                <div class="text-center pt-5">
                    <v-btn rounded class="graybtn" width="100%" @click.stop="deleteCoupon(item.id)">削除する</v-btn>
                </div>
            </v-overlay>

            <appDialogue ref="appDialogue" @use="use" @pollingStop="pollingStop"></appDialogue>
            <appBarcodeDialogue ref="appBarcodeDialogue" @use="use" @pollingStop="pollingStop"></appBarcodeDialogue>
            <ticketConfirmDialog ref="ticketConfirmDialog" @use="use"></ticketConfirmDialog>
            <ticketConfirmBarcodeDialog ref="ticketConfirmBarcodeDialog" @use="use"></ticketConfirmBarcodeDialog>

            <v-overlay :value="loading">
              <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
            </v-overlay>

        </v-card>

</template>

<script>
import ticketConfirmDialog from '../../components/ticket_confirm_dialog.vue'
import ticketConfirmBarcodeDialog from '../../components/ticket_confirm_barcode_dialog.vue'
import appDialogue from '../../components/ticket_dialogue.vue'
import appBarcodeDialogue from '../../components/ticket_barcode_dialogue.vue'
import scratchDialogue from "@/views/coupon/scratch_dialogue.vue"
export default {
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    components: {
        appDialogue,
        appBarcodeDialogue,
        scratchDialogue,
        ticketConfirmDialog,
        ticketConfirmBarcodeDialog
    },
    data() {
      return {
        loading: false,
        used: true,
        show: false,
        intervalId: undefined,
        push_date: null,
      };
    },
    methods: {
        refToScracthOpen() {
            this.$refs.scratchDialogue.open()
        },
        refToParentOpen() {
            this.$refs.appDialogue.open()
        },
        closeWin() {
            this.$router.go({path: this.$router.currentRoute.path, force: true});
        },
        closeLose() {
            this.$router.push({ name: 'coupon_list', query: {}})
        },
        async use(code) {
          try {
            // 有効チェック
            this.couponCheck(this.item);
            //loadingを表示
            this.loading = true
            //QR認証を設定している場合はポーリングされているので、ポーリングを停止
            this.pollingStop()
            //念の為もう一度ローカルから取得（後ほど処理変える）
            this.init = this.storageGet('*')

            var params = {
              'sid': this.init.sid,
              'device_uid': this.init.device_uid,
              'device_id': this.init.device_id,
              'os': this.init.os,
              'key': this.init.key,
              'id': this.init.id,
              'code': code,
              'type': "3",
              'shop_id': String(this.$props.item.shop_id),
            }

            var res = await this.apiCall('/user/ticket/use', params, 'post', 0);
            if (!res) { return false }

            this.$set(this, 'result', res);
            this.$router.go({path: this.$router.currentRoute.path, force: true});
          } catch(e) {
            this.callDialog('エラー', 'エラーが発生いたしました。', 3);
          } finally {
            // 正常, 異常に関わらず処理完了時はスピナー, ボタンdisabled解除
            this.loading = false
            this.$refs.appDialogue.setBtnDisabled(false)
            this.$refs.appBarcodeDialogue.setBtnDisabled(false)
            this.$refs.ticketConfirmDialog.setBtnDisabled(false)
            this.$refs.ticketConfirmBarcodeDialog.setBtnDisabled(false)
          }
        },
        async lottery() {
          try {
            //loadingを表示
            this.loading = true
            //念の為もう一度ローカルから取得（後ほど処理変える）
            this.init = this.storageGet('*')

            var params = {
              'sid': this.init.sid,
              'device_uid': this.init.device_uid,
              'device_id': this.init.device_id,
              'os': this.init.os,
              'key': this.init.key,
              'id': this.init.id,
            }

            var res = await this.apiCall('/user/coupon/lottery', params, 'post', 0);
            if (!res) {
              this.loading = false;
              return false
            } else {
              this.$refs.scratchDialogue.lottery(res.win_flg)
              this.$refs.scratchDialogue.open()
            }

            this.$set(this, 'result', res);

            this.loading = false


          } catch(e) {
            this.loading = false
            this.callDialog('エラー', 'エラーが発生いたしました。', 3);
          }
        },
        async scratch() {
          try {
            //loadingを表示
            this.loading = true
            //念の為もう一度ローカルから取得（後ほど処理変える）
            this.init = this.storageGet('*')

            var params = {
              'sid': this.init.sid,
              'device_uid': this.init.device_uid,
              'device_id': this.init.device_id,
              'os': this.init.os,
              'key': this.init.key,
              'id': this.init.id,
            }

            var res = await this.apiCall('/user/coupon/scratch', params, 'post', 0);
            if (!res) {
              this.loading = false;
              return false
            } else {
              this.loading = false
              this.$refs.scratchDialogue.showResult()
            }
          } catch(e) {
            this.loading = false
            this.callDialog('エラー', 'エラーが発生いたしました。', 3);
          }
        },
        async openUseDialog(item) {
          // 有効チェック
          this.couponCheck(item);

          if (item.auth_flg == 1) {

              var qr_url = "useTicket://?id=" + item.id + "&device_uid=" + this.init.device_uid + "&type=3" + "&os=" + this.init.os + "&device_id=" + this.init.device_id + "&sid=" + this.init.sid + "&key=" + this.init.key + "&qrflg=1";

              if (item.barcode_flg === 1){
                // ダイアログ表示
                this.$refs.appBarcodeDialogue.open(2, item.id, item.auth_flg, qr_url,item);
              }else{
                // ダイアログ表示
                this.$refs.appDialogue.open(2, item.id, item.auth_flg, qr_url);
              }

              var count = 0
              var baseData = this.storageGet('*')
              var apiCall  = this.apiCall
              var router = this.$router
              var callDialog = this.callDialog
              var thisone = this

              var useCheck = async function() {
              console.log("checking...")
                count++

                var params = { params:{
                  'sid': baseData.sid,
                  'service_cd': baseData.service_cd,
                  'device_uid': baseData.device_uid,
                  'device_id': baseData.device_id,
                  'os': baseData.os,
                  'key': baseData.key,
                  'id': baseData.id,
                }}

                try{
                  var res = await apiCall('/user/coupon', params, 'get');
                  if (res.usage_count != item.usage_count || res.use_flg == 1) {
                      thisone.pollingStop()
                      router.go({path: router.currentRoute.path, force: true});
                  }
                  if (!res) return false;
                } catch(e) {
                    callDialog('通信エラー', 'ネットワークの状態が不安定です。再度お試しください', 3);
                }
              }

              thisone.intervalId = setInterval(function(){ //3秒ごとにapiを叩く
                  console.log('polling START');
                  useCheck();
                  if (count >= 20){ //1分後にポーリング終了
                      thisone.pollingStop()
                  }
              }, 3000);

          } else {
            if (item.barcode_flg === 1){
              this.$refs.ticketConfirmBarcodeDialog.open(item)
            }else{
              this.$refs.ticketConfirmDialog.open()
            }
          }
        },

        async deleteCoupon(coupon_id) {
          try {
            //loadingを表示
            this.loading = true
            this.used = false
            //念の為もう一度ローカルから取得（後ほど処理変える）
            this.init = this.storageGet('*')

            var params = {
              'sid': this.init.sid,
              'device_uid': this.init.device_uid,
              'device_id': this.init.device_id,
              'os': this.init.os,
              'key': this.init.key,
              'id': coupon_id,
            }

            var res = await this.apiCall('/user/coupon/delete', params, 'post', 0);
            if (!res) {
              this.loading = false
              return false
            }

            this.$set(this, 'result', res);

              if (this.$router.history.router.beforeHooks.length == 0){
                this.$router.push({ name: 'coupon_list', query: {}})
              } else {
                this.$router.go(-1)
              }
          } catch(e) {
            this.loading = false
            this.callDialog('エラー', 'エラーが発生いたしました。', 3);
          }
        },
        pollingStop() {
          console.log('polling END');
          clearInterval(this.intervalId);
        },
        async couponCheck(item) {
          var params = { params:{
            'sid': this.init.sid,
            'service_cd': this.init.service_cd,
            'device_uid': this.init.device_uid,
            'device_id': this.init.device_id,
            'os': this.init.os,
            'key': this.init.key,
            'id': item.id,
          }}
          // クーポン取得
          var res = await this.apiCall('/user/coupon', params, 'get');
          console.log(res);
          if (!res || !res.id) {
            this.callDialog('エラー', 'エラーが発生いたしました。', 3);
          }
        }
    },
    created() {
      this.getUrlParam()
      this.init = this.storageGet('*')
      this.push_date = this.init.create_date;
    },
}
</script>

<style scoped>
/* vue css override */

.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
    border-radius: 10px;
    margin-bottom: 40px;
}

/* original css */
@import url('https://fonts.googleapis.com/css?family=Oswald&display=swap');

.coupondetail {
    margin-top: 20px;
    background-color: #EEEEEE;
    padding-top: 10px;
}

.detailhead {
    text-align: center;
    font-size: 11px;
    margin: 0 0 10px;
}

.topbar {
    height: 15px;
    margin-bottom: 15px;
}

.vdbar {
    width: 94%;
    margin: 16px auto 0;
}

.vdbar2 {
    width: 94%;
    margin: 0 auto 16px;
}

.titlebottombar {
    height: 1px;
    width: 30%;
    margin: 0 auto;
}

.chips {
    padding: 3px 10px;
    color: #fff;
    background-color: #EB762F;
    font-size: 10px;
    transform: scale(0.9);
    transform-origin: left center;
    border-radius: 20px;
}

.chips.birth {
	background-color: #F26474;
}

.viewflagbox {
    position: absolute;
    bottom: 12px;
    right: 12px;
    z-index: 50;
    padding: 2px 15px;
    color: #fff;
    background-color: #9D9D9D;
    font-size: 10px;
    transform: scale(0.9);
    transform-origin: left center;
    border-radius: 5px !important;
}

.list {
    padding: 16px;
}

.list .col {
    padding: 8px;
}

.list h2 {
    font-weight: bold;
    font-size: 11px;
    line-height: 20px;
    color: #9d9d9d;
}

.list p {
    font-size: 14px;
    line-height: 20px;
    color: #333;
    margin-bottom: 0;
    font-weight: bold;
}

.list p.notes {
    font-size: 11px;
    font-weight: normal;
    line-height: 16px;
}

.coupontitle {
    font-weight: bold;
    font-size: 18px;
    line-height: 27px;
    color: #333;
    text-align: center;
    display: block;
    padding: 10px 0 5px;
}

.coupon_contents {
    padding: 16px;
}

/* NEW_DEV-2185 cyber start */
.coupon_contents >>> p {
    margin-bottom: 0px;
}
/* NEW_DEV-2185 cyber end */

.coupondates p {
    font-weight: 500;
    font-size: 10px;
    line-height: 13px;
    margin-bottom: 5px;
    color: #9d9d9d;
    transform: scale(0.9);
    transform-origin: left center;
}

.flgtext {
    font-size: 16px;
    font-weight: bold;
    padding-top: 5px;
}

.usage {
    font-size: 16px;
    color: #333;
    line-height: 24px;
    text-align: center;
    padding-bottom: 10px;
}
.usage span.big {
    font-size: 40px;
    font-weight: bold;
    font-family: 'Oswald', sans-serif;
}
.bold {
    font-weight: bold;
}
</style>
<style>
  .coupon_contents p img {
    max-width: 100%;
  }
</style>
